import React from "react";
import "../../App.css";
import EventMltVip2 from "./EventMltVip2.js";
import HeaderMlt from "./HeaderMlt.js";
import { Navigate } from "react-router-dom";

function EventMltComplete() {
  var role = localStorage.getItem('role');

  switch (role) {
    case 'Visit Requester':
    case 'Requester':
      return (
        <div>
          <Navigate to={`/AppRequester`} replace />
        </div>
      )
    case 'MLTUser':
    case 'MLTCoordinator':
      return (
        <div>
          <HeaderMlt />
          <EventMltVip2 />
        </div>
      )
    case 'Admin':
      return (
        <div>
          <Navigate to={`/AppAdmin`} replace />
        </div>
      )
    case 'Family':
    case 'FamilyCoordinator':
      return (
        <div>
          <Navigate to={`/AppFamily`} replace />
        </div>
      )
    default:
      return (
        <div>
          <Navigate to="/" replace />
        </div>
      )
  }
}

export default EventMltComplete;
